import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { User } from '../models/user';

@Injectable()
export class UserService {
  user = new User;

  // user$: Observable<User>;
  // private userSubject: Subject<User>;

  constructor() {
    // this.userSubject = new Subject<User>();
    // this.user$ = this.userSubject.asObservable();
  }

  setAuthentication(response) {
    localStorage.setItem('bearer', response.access_token);
    localStorage.setItem('roleId', response.roles);
    localStorage.setItem('userId', response.userID);
    localStorage.setItem('expiresIn', response.expires_in);
  }

  setUserInformation(response) {
    localStorage.setItem('firstName', response.FirstName);
    localStorage.setItem('lastName', response.LastName);
    localStorage.setItem('profilePhotoPath', response.ProfilePhotoPath);
  }

  getUserInformation() {
    this.user.firstName = localStorage.getItem('firstName');
    this.user.lastName = localStorage.getItem('lastName');
    return this.user;
  }

  // remove() {
  //   this.selectedModal = {};
  // }

  // open() {
  //   this.selectedModal.open();
  // }

  // close() {
  //   this.selectedModal.close();
  // }    
}